




































// We're going to need
import Vue from 'vue';

// Search Result object interface
type searchResultObject = Show.Details | Person.Details | Movie.Details;
// Search data interface
interface searchResultsDataInterface {
    results: searchResultObject[];
    currentPage: number;
    dataLoaded: boolean;
}
// Export our vue instance
export default Vue.extend({
   data(): searchResultsDataInterface {
       return {
           results: [],
           currentPage: parseInt(this.$route.params.page, 10) || 1,
           dataLoaded: false
       };
   },
   computed: {
       searchQuery(): string {
           return this.$store.state.searchQuery || this.$route.params.query ;
       },
       loading(): boolean {
           return !this.results.length && !this.dataLoaded ;
       }
   },
   methods: {
       buildImage(image?: string): string {
           // If we have an item that does not have a poster, then we simply use a placeholder image
           return !image ? 'https://placehold.it/300x400?text=No+Image+Available' : this.$tmdb.buildImageUri(image, 'w300');
       },
       capitalize(str: string): string {
           str = str.toLowerCase();
           return str.charAt(0).toUpperCase() + str.slice(1);
       },
       nextPage() {
           this.currentPage++;
       },
       prevPage() {
           this.currentPage--;
       },
       goToPage(page: number ) {
           this.currentPage = page;
       },
       cleanScriptTags(input: string): string {
           return input.replace(/<script.*?>.*?<\/script>/g, '');
       },
       loadResults(): void {
            this.$tmdb.get('search/multi', {
                params: {
                    query: this.searchQuery,
                    page: this.currentPage
                }
            }).then(( { data } ) => {
                this.results = data.results;
                this.dataLoaded = true;
            }).catch((err) => {
                console.error(err);
                this.dataLoaded = true;
            });
       }
   },
   beforeRouteUpdate(to, from, next): void {
       this.dataLoaded = false;
       this.loadResults();
       next();
   },
   created(): void {
       this.loadResults();
   }
});
